import * as Blockly from 'blockly/core'
import { clipboard } from 'blockly/core'
import { trackEvent } from '../analytics/plausible.js'

export function enableTapToAdd(workspace) {
  const isMobile = window.matchMedia('(max-width: 768px)').matches
  if (!isMobile) return

  const flyout = workspace.getFlyout()
  if (!flyout) return

  const flyoutWorkspace = flyout.getWorkspace()
  const injectionDiv = flyoutWorkspace.getInjectionDiv()
  if (!injectionDiv) return

  const handleTap = (event) => {
    const flyoutBlock = findBlockAtPoint(flyoutWorkspace, event)
    if (!flyoutBlock) return

    const copyData = clipboard.copy(flyoutBlock)
    if (!copyData) return

    const pasted = clipboard.paste(workspace)
    if (pasted && pasted.translate) {
      const metrics = workspace.getMetrics()
      const offsetX = metrics.viewWidth / 2 - 60
      const offsetY = metrics.viewHeight / 2 - 30
      pasted.translate(offsetX, offsetY)
      pasted.snapToGrid?.()
      pasted.select?.()
    }

    flashBlock(pasted)
    if (window.navigator.vibrate) window.navigator.vibrate(10)

    trackEvent('block_added', {
      blockType: flyoutBlock.type,
      category: 'events',
      viaTapOrDrag: 'tap',
    })

    event.preventDefault()
    event.stopPropagation()
  }

  injectionDiv.addEventListener('click', handleTap, { capture: true, passive: false })

  workspace.addChangeListener((e) => {
    if (e.type === Blockly.Events.BLOCK_CREATE && e.recordUndo) {
      const block = workspace.getBlockById(e.blockId)
      if (block) flashBlock(block)
    }
  })
}

function findBlockAtPoint(flyoutWorkspace, event) {
  const clientX = event.clientX ?? 0
  const clientY = event.clientY ?? 0
  const allBlocks = flyoutWorkspace.getAllBlocks(false)
  for (const block of allBlocks) {
    const svg = block.getSvgRoot()
    if (!svg) continue
    const rect = svg.getBoundingClientRect()
    if (
      clientX >= rect.left &&
      clientX <= rect.right &&
      clientY >= rect.top &&
      clientY <= rect.bottom
    ) {
      return block
    }
  }
  return null
}

function flashBlock(block) {
  if (!block) return
  const svg = block.getSvgRoot()
  if (!svg) return
  svg.classList.add('tm-block-flash')
  setTimeout(() => svg.classList.remove('tm-block-flash'), 300)
}
